export function checkIsDebugger(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const devtools = /./;
    devtools.toString = () => {
      resolve(true);
      return '';
    };
    console.log(devtools);
  });
}
